import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'E-Mail-Nachrichten',
  labels: {
    view_full_message: 'Vollständige Nachricht anzeigen',
    status: 'Status:',
    on: 'An',
    off: 'Aus',
    next_send: 'Nächster Versand: {{date}}.',
  },
  descriptions: {
    welcome:
      'Wird einmalig versendet, wenn sich ein Kunde für Ihre Marketing-E-Mails anmeldet, außer bei Anmeldungen über das Formular Ihrer Storefront. Jeder Kunde erhält nur eine der E-Mails Willkommen, Willkommen im Mitgliederclub und Startangebot.',
    welcome_members_club:
      'Wird einmalig versendet, wenn sich jemand über das Formular Ihrer Storefront anmeldet und kein Anmelde-Gutscheincode eingerichtet ist, oder Ihrer VIP-Mitgliederliste beitritt. Jeder Kunde erhält nur eine der E-Mails Willkommen, Willkommen im Mitgliederclub und Startangebot.',
    storefront_promo:
      'Wird einmalig versendet, wenn sich jemand über das Formular Ihrer Storefront anmeldet und ein Anmelde-Gutscheincode eingerichtet ist. Die E-Mail enthält den persönlichen Gutscheincode.',
    launch_deal:
      'Wird einmalig an Ihre importierten Kunden versendet, 30 Minuten nachdem Ihr Restaurant live geht. Kunden, die bereits Willkommen oder Willkommen im Mitgliederclub erhalten haben, werden übersprungen.',
    we_miss_you:
      'Wird an Abonnenten versendet, deren letzte Bestellung mehr als 45 Tage zurückliegt. Wird jeden Morgen geprüft; ein Kunde erhält sie höchstens einmal alle 45 Tage.',
    happy_friday:
      'Wird um 08:00 UTC am ersten Freitag jedes geraden Monats (Februar, April, Juni, August, Oktober, Dezember) an alle Abonnenten versendet.',
    lazy_sunday:
      'Wird um 08:00 UTC am ersten Sonntag jedes ungeraden Monats (Januar, März, Mai, Juli, September, November) an alle Abonnenten versendet.',
    loyalty_program:
      'Wird versendet, wenn das Cashback-Guthaben eines Kunden den Mindestbetrag erreicht, den er einlösen kann. Ein Kunde erhält sie höchstens einmal alle 30 Tage.',
    you_might_also_like:
      'Wird 3 Tage nach einer Bestellung versendet, die mindestens 2 Stück desselben Artikels ab 6,00 enthält, und empfiehlt einen Ihrer beliebtesten Artikel. Ein Kunde erhält sie höchstens einmal alle 30 Tage.',
  },
  tiles: {
    sends_count: 'Nachrichten gesendet',
    delivery_rate: 'Zustellungsrate',
    delivered_suffix: 'zugestellt',
    open_rate: 'Öffnungsrate',
    opened_suffix: 'geöffnet',
    click_rate: 'Klickrate',
    clicked_suffix: 'geklickt',
    spam_report_rate: 'Spam-Report-Rate',
    spam_reports_suffix: 'Berichte',
    unsubscribe_rate: 'Abmelderate',
    unsubscribes_suffix: 'Abmeldungen',
  },
  toasts: {
    failed_to_update_status: 'Status konnte nicht aktualisiert werden',
    failed_to_load_data: 'Daten konnten nicht geladen werden',
  },

  preview_modal: {
    title: 'Vorschau des Templates',
    labels: {
      subject: 'Betreff:',
      close: 'Schließen',
    },
    toasts: {
      failed_to_load_data: 'Vorschau-Daten konnten nicht geladen werden',
    },
    template_data: {
      recipient_name: '&lt;Vorname&gt;',
    },
  },
};
